// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__381iR","author":"Table_author__2BsLW","authorImage":"Table_authorImage__1Jwmd","unreadRow":"Table_unreadRow__3IWyQ"};